import {
	STORE_LIST_REQUESTING,
	STORE_DETAIL_REQUESTING,
	UPDATE_STORE_REQUESTING,
	ADD_IMAGE_REQUESTING,
	DELETE_IMAGE_REQUESTING,
	OTP_REQUESTING,
	VERIFY_OTP_REQUESTING,
	OTP_REQUESTING_ERROR,
	VERIFY_OTP_ERROR,
	TOTAL_STORE_LIST_REQUESTING,
} from './types';

const getStoreList = (payload) => ({
	type: STORE_LIST_REQUESTING,
	payload,
});

const getTotalStoreList = (payload) => ({
	type: TOTAL_STORE_LIST_REQUESTING,
	payload,
});

const getStoreDetail = (payload) => ({
	type: STORE_DETAIL_REQUESTING,
	payload,
});

const updateStore = (payload) => ({
	type: UPDATE_STORE_REQUESTING,
	payload,
});

const addStoreImage = (payload) => ({
	type: ADD_IMAGE_REQUESTING,
	payload,
});

const deleteStoreImage = (payload) => ({
	type: DELETE_IMAGE_REQUESTING,
	payload,
});

const getStorePhoneOtp = (phoneNumber) => ({
	type: OTP_REQUESTING,
	phoneNumber,
});

const verifyStorePhoneOtp = (payload) => ({
	type: VERIFY_OTP_REQUESTING,
	payload,
});

const changeOtpStatus = () => ({
	type: OTP_REQUESTING_ERROR,
});

const changeVerifyOtpStatus = () => ({
	type: VERIFY_OTP_ERROR,
});

export {
	getStoreList,
	getTotalStoreList,
	getStoreDetail,
	updateStore,
	addStoreImage,
	deleteStoreImage,
	getStorePhoneOtp,
	verifyStorePhoneOtp,
	changeOtpStatus,
	changeVerifyOtpStatus,
};
